import { IntegrationSettingsEntry, IntegrationSettingsLocationLevelForm } from 'modules/integrationSettings/types';
import { IntegrationSettingsTable } from './IntegrationSettingsTable';
import { Box } from '@mui/material';

interface LocationTabProps {
  integrationSettings: IntegrationSettingsEntry[];
  tableData: IntegrationSettingsLocationLevelForm[];
}

export const LocationTab = ({ integrationSettings, tableData }: LocationTabProps) => {
  return (
    <Box mt={2}>
      <IntegrationSettingsTable integrationSettings={integrationSettings} tableData={tableData} />
    </Box>
  );
};
